import React from 'react'

import {  ExAccInfoModalContent, ExAccInfoModalOKBtn } from '../../../../components/ui/Button';
import { ExAccModalContent, ModalBody,  ModalFooterCenter, WarningModalBackground } from '../../../../components/ui/Modal';
import { ErrorIcon } from './Icons/ErrorIcon';
import { SuccessIcon } from './Icons/SuccessIcon';
import { IMessages } from '../AccountInfo';

export interface ModalProps {
    onClose: () => void
    status: "success" | "error"
    messages: IMessages
}

const SelectIcon = ({status}: {status: "success" | "error"}) => {
    if (status === "success") { 
        return <SuccessIcon /> 
    }

    if (status === "error") {
        return <ErrorIcon />
    }

    return <SuccessIcon />
}

interface IMessage {
    messages: IMessages
    status: "success" | "error"
}

const SelectMessage = ({status, messages}: IMessage) => {
    if (status === "success") { 
        return <div style={{width: "100%"}}>{messages.success.messages.map((item, index) => <p key={index}>{item}</p>)}</div>
    }

    if (status === "error") {
        return <div style={{width: "100%"}}>{messages.error.messages.map((item, index) => <p key={index}>{item}</p>)}</div>
    }

    return null
}

export const ExAccInfoModal = ({onClose, status, messages}: ModalProps) => {
    return <WarningModalBackground>
        <ExAccModalContent>
            <ModalBody>
                <div style={{opacity: "0.65"}}>
                    <SelectIcon status={status} />
                </div>
                <ExAccInfoModalContent>
                    <SelectMessage status={status} messages={messages} />
                </ExAccInfoModalContent>
            </ModalBody>
            <ModalFooterCenter>
                <ExAccInfoModalOKBtn onClick={onClose}>
                    {'ОК'}
                </ExAccInfoModalOKBtn>
            </ModalFooterCenter>
        </ExAccModalContent>
    </WarningModalBackground>
}
